<template>
  <div class="info24-wrapper flex center-all">
    <div
      id="info24"
      class="info flex center-all"
      @click.stop>
      <p>Why I am seeing this?</p>
      <SBIcon
        :icon="SBIconList.INFO"
        :color="SBColors.blackPrimary"
        :size="12"/>
      <b-popover
        target="info24"
        triggers="hover"
        placement="auto"
        custom-class="big">
        <!-- TODO change id css -->
        <div>
          <h1>WhatsApp 24 hours messaging window</h1>
          <p>You may only continue a conversation with this contact if you
            send an approved WhatsApp Message Template.
            <br><br>
            Based on WhatsApp Business Policies, if more than 24 hours have passed from the
            last message sent by the contact, you may only follow up by sending an approved
            WhatsApp Message Template. Learn more about WhatsApp Business Policies
            <a
              class="link"
              href="https://www.whatsapp.com/legal/business-policy/"
              target="_blank">here</a>.
          </p>
        </div>
      </b-popover>
    </div>
    <div
      class="more-than-24-hours flex center-all"
      @click="$emit('click')">
      <SBIcon
        :icon="SBIconList.WHATSAPP_LOGO_THICK"
        :color="SBColors.bluePrimary"
        :size="14"/>
      <p>Send WhatsApp Message Template</p>
    </div>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'MoreThan24Hours',
  components: {
    SBIcon,
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
};
</script>

<style lang="scss" scoped>
.info24-wrapper {
  position: relative;
  .info {
    position: absolute;
    top: -28px;
    cursor: default;
    padding: 3px 9px;
    z-index: 51;
    border-radius: 10px;
    background-color: $white;

    p {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.4;
      color: $blackPrimary;
    }

    .sb-icon {
      margin-left: 5px;
    }
  }

  .more-than-24-hours {
    cursor: pointer;
    border-radius: 5px;
    padding: 9px;
    margin: 0 15px 15px;
    background-color: $blueUltraLight;
    border: dashed 1px $bluePrimary;
    background-color: $blueExtraLight;
    width: 100%;

    &:hover {
      background-color: #E8F2FF;
    }

    .sb-icon {
      margin-right: 5px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;
      color: $bluePrimary;
    }
  }
}
</style>
